<template>
    <input class="jira-update-button" width="100px" type="image" :src="displayImg" @click="update" :alt="$lang('synchornizacja z Jira')">
</template>

<script>

import ShowNotification from "../mixins/show-notification";

export default {
    name: "jira-update-button",
    mixins: [ShowNotification],
    data: function () {
        return {
            synchronizing: false,
            displayImg: ""
        }
    },
    props: {
        url: {type: String, required: true},
        task: {type: Object, required: true},
        img: {type: String, required: true},
        imgHover: {type: String, required: true},
    },
    methods: {
        update: function () {
            this.displayImg = this.imgHover;
            let self = this;
            axios.post(this.url, {id: this.task.jira_id})
            .then(function ({data}) {
                if (data.update_status && data.update_status === 200) {
                    self.showNotification("success", self.$lang("Synchronizacja zakończyła się sukcesem"));
                    window.location.reload();
                } else {
                    self.showNotification("error", data.msg);
                }
                self.displayImg = self.img;
            })
            .catch(function (err) {
                console.log(err);
                self.showRequestErrorNotification();
                self.displayImg = self.img;
            });
        }
    },
    mounted() {
        this.displayImg = this.img;
        let image = jQuery('.jira-update-button');
        let self = this;
        image.mouseover(function () {
            self.displayImg = self.imgHover;
        });
        image.mouseout(function () {
            self.displayImg = self.img;
        });
    },
}
</script>

